<template>
    <div class="dashboard">
        <sites></sites>
    </div>
</template>

<script>

import { mapMutations } from 'vuex'

import Sites from '../Sites/Sites'

export default {

  components: {

    Sites
  },

  methods: {

    ...mapMutations([
      'setViewname'
    ]),

    ...mapMutations('site', [
      'closeAllSiteDetailPages',
      'setSiteDetailId'
    ])
  },

  beforeRouteLeave (to, from, next) {
    this.closeAllSiteDetailPages()
    this.setSiteDetailId(0)
    next()
  },

  created () {
    this.setViewname(this.$t('dashboard.viewtitle'))
  }
}
</script>
